// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavSecundario_nav__PpJp2","btn":"NavSecundario_btn__gWndz"};